// actionTypes.js
export const SET_VALUE_R = 'SET_VALUE_R';
export const SET_A_CONFIRMER = 'SET_A_CONFIRMER';
export const SET_A_PLACER = 'SET_A_PLACER';
export const SET_STATUT_R = 'SET_STATUT_R';
export const SET_ANNEE_R = 'SET_ANNEE_R';
export const SET_A_REMBOURSER = 'SET_A_REMBOURSER';
export const SET_ABANDONNEES = 'SET_ABANDONNEES';
export const SET_CURRENT_PAGE_R = 'SET_CURRENT_PAGE_R';
export const SET_SELECTED_OPTIONS_R = 'SET_SELECTED_OPTIONS_R';
export const SET_ORDER_R = 'SET_ORDER_R';
export const SET_SORT_FIELD_R = 'SET_SORT_FIELD_R';
export const SET_FINALISEE= 'SET_FINALISEE';
